module.exports = __webpack_public_path__ + "static/media/google-play-badge.90ec3196.png";